import useIsSmall from "@/hooks/useIsSmall";
import { MerchantServicePriceType } from "@/models/club";
import { MerchantService } from "@/services/appointment/type";
import { ActionIcon, Blockquote, Group, Menu, Stack, Text } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

type Props = {
  service: MerchantService;
  catId: number;
};

function ServiceItem({ service, catId }: Props) {
  const isSmall = useIsSmall();
  const navigate = useNavigate();
  console.log(service);
  return (
    <Blockquote color="blue" bg="white" p="xs" >
      <Group justify="space-between" >
        <Stack gap="xs">
          <Text size="sm" fw="500">
            {service?.title}
          </Text>

          <Text size="xs" c="dimmed">
            هر {service?.durationPartInMinute} دقیقه
          </Text>
          <Text size="xs" fw="500">
            {service?.priceType === MerchantServicePriceType.Value2
              ? "رایگان"
              : service?.priceType === MerchantServicePriceType.Value0
                ? "مبلغ"
                : "قیمت از"}{" "}
            {service?.priceType === MerchantServicePriceType.Value2
              ? ""
              : service?.startingPrice?.toLocaleString() ?? 0}
            {service?.priceType === MerchantServicePriceType.Value2
              ? ""
              : " ریال "}
          </Text>

        </Stack>
        {!isSmall ? (
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <ActionIcon variant="subtle" color="dark">
                <IconDotsVertical />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={() =>
                navigate(`editService`, {
                  state: {
                    service: service,
                    categoryId: catId,
                  },
                })
              }>
                ویرایش
              </Menu.Item>

            </Menu.Dropdown>
          </Menu>

        ) : (
          <></>
        )}
      </Group>

    </Blockquote>
  );
}

export default ServiceItem;
